import produce from "immer"
let auth = localStorage.getItem('state') ? JSON.parse(localStorage.getItem('state')).auth : {
    isAuthenticated: false,
    token: false,
    user: false,
    loginText: false
}
const initialState = {
    token: auth.token,
    loginText: 'Login',
    isAuthenticated: auth.isAuthenticated,
    user: auth.user,

}

export const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN_USER':
            return produce(state, (draft) => {
                draft.loginText = 'Login'
                draft.isAuthenticated = true
                draft.token = action.payload.token
                draft.user = action.payload.user

            })

        case 'LOGOUT':
            localStorage.clear()
            return produce(state, (draft) => {
                draft.loginText = false
                draft.isAuthenticated = false
                draft.token = false
                draft.user = false

            })

        case 'CHANGE_USER_IMAGE':
            return produce(state, (draft) => {
                draft.user.image = action.payload
            })

        case 'CHANGE_USER_NAME':
            return produce(state, (draft) => {
                draft.user.name = action.payload
            })

        case 'CHANGE_USER_EMAIL':
            return produce(state, (draft) => {
                draft.user.email = action.payload
            })

        case 'LOAD_USER_DATA':
            return produce(state, (draft) => {
                draft.user = action.payload
            })

        case 'SAVE_BASE_CURRENCY':
            return produce(state,(draft)=>{
                draft.user.baseCurrency=action.payload.currency
                draft.user.symbol=action.payload.symbol
            })

        default:
            return state;

    }
}